import HttpClient from '@/common/lib/http-client'
import { ITag, Tag } from '@/common/models/data/dashboard/posts/tag'

import { tags as Api } from '@/app/api'

class TagsRepository {
    async bySlug (slug: string): Promise<ITag> {
        const response = await HttpClient.getJson<ITag>(Api.bySlug(slug))

        return new Tag(response)
    }
}

export default new TagsRepository()
